/* Honey & Paw — email-gated wishlist.
   Injects a heart into every product card. Saving a favorite requires an
   email / account first (data capture), then persists in localStorage.
   Port target for the real theme: store on the customer (metafield) + Klaviyo. */
(function () {
  var WKEY = 'hp_wishlist', EKEY = 'hp_email';
  var X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7-4.5-9.5-9C1 9 2.5 5.5 6 5.5c2 0 3.2 1.2 4 2.3.8-1.1 2-2.3 4-2.3 3.5 0 5 3.5 3.5 6.5C19 16.5 12 21 12 21z"/></svg>';
  var modal = null, overlay = null, pending = null, lastFocus = null;
  var wl = load();

  function load() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function save() { try { localStorage.setItem(WKEY, JSON.stringify(wl)); } catch (e) {} }
  function hasEmail() { return !!localStorage.getItem(EKEY); }

  function keyFor(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  function titleFor(card) {
    var t = card.querySelector('.card__heading, .card__information .card__heading, h3');
    return t ? t.textContent.trim() : 'this item';
  }
  function markHearts() {
    document.querySelectorAll('.hp-wish').forEach(function (w) {
      var card = w.closest('.card-wrapper, .card, [data-product-card]');
      if (!card) return;
      var k = keyFor(card), on = !!(k && wl.indexOf(k) >= 0);
      w.classList.toggle('saved', on);
      w.setAttribute('aria-pressed', on ? 'true' : 'false');
      w.setAttribute('aria-label', on ? 'Saved to wishlist' : 'Save to wishlist');
    });
  }
  function toggle(card) {
    var k = keyFor(card); if (!k) return;
    var i = wl.indexOf(k);
    if (i >= 0) wl.splice(i, 1); else wl.push(k);
    save(); markHearts();
  }

  function buildModal() {
    if (modal) return;
    overlay = document.createElement('div'); overlay.className = 'hp-wl-overlay'; overlay.id = 'hpWlOverlay';
    modal = document.createElement('div'); modal.className = 'hp-wl-modal'; modal.id = 'hpWlModal';
    modal.setAttribute('role', 'dialog'); modal.setAttribute('aria-modal', 'true'); modal.setAttribute('aria-label', 'Save to wishlist');
    modal.innerHTML =
      '<button class="hp-wl-close" id="hpWlClose" aria-label="Close">' + X + '</button>' +
      '<div class="hp-wl-emoji">' + HEART + '</div>' +
      '<h3>Save your favorites</h3>' +
      '<p>Create your wishlist so your picks are waiting when you come back. Add your email or create an account.</p>' +
      '<form id="hpWlForm" novalidate><input type="email" id="hpWlEmail" required placeholder="you@email.com" aria-label="Email address" autocomplete="email"><button class="button button--primary" type="submit">Save to wishlist</button></form>' +
      '<a class="hp-wl-acct" href="/account/register">Create an account instead</a>';
    document.body.appendChild(overlay); document.body.appendChild(modal);
    overlay.addEventListener('click', closeModal);
    modal.querySelector('#hpWlClose').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
    modal.querySelector('#hpWlForm').addEventListener('submit', function (e) {
      e.preventDefault();
      var input = modal.querySelector('#hpWlEmail'), em = input.value.trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { input.classList.add('invalid'); input.focus(); return; }
      localStorage.setItem(EKEY, em);
      closeModal();
      if (pending) { toggle(pending); pending = null; }
    });
  }
  function openModal() { buildModal(); lastFocus = document.activeElement; overlay.classList.add('open'); modal.classList.add('open'); document.body.style.overflow = 'hidden'; setTimeout(function () { modal.querySelector('#hpWlEmail').focus(); }, 60); }
  function closeModal() { if (!modal) return; overlay.classList.remove('open'); modal.classList.remove('open'); document.body.style.overflow = ''; if (lastFocus && lastFocus.focus) lastFocus.focus(); }

  function injectHearts() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('.hp-wish')) return;
      // product cards only (skip collection cards, which have no /products/ link)
      if (card.classList.contains('collection-card-wrapper') || !card.querySelector('a[href*="/products/"]')) return;
      var media = card.querySelector('.card__media') || card.querySelector('.card__inner');
      if (!media) return;
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'hp-wish'; b.setAttribute('aria-label', 'Save to wishlist'); b.setAttribute('aria-pressed', 'false');
      b.innerHTML = HEART;
      media.appendChild(b);
    });
    markHearts();
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    injectHearts();
    // re-inject after section re-renders (theme editor, quick-add, etc.)
    document.addEventListener('shopify:section:load', injectHearts);
    document.addEventListener('click', function (e) {
      var w = e.target.closest('.hp-wish'); if (!w) return;
      e.preventDefault(); e.stopPropagation();
      var card = w.closest('.card-wrapper, .card, [data-product-card]'); if (!card) return;
      if (!hasEmail()) { pending = card; openModal(); return; }
      toggle(card);
    });
  });
})();
